import { CircularProgress } from "@mui/material";
import { BotaoCustomizado } from "./botao";

interface BotaoProps {
    modelo?: 'primario' | 'secundario' | 'outros',
    texto?: string,
    variante?: "text" | "outlined" | "contained" | undefined,
    onClick?: () => void,
    cor?: string,
    corDeFundo?: string
    carregando?: boolean
    altura?: string,
    largura?: string,
    desabilitarBotao?: boolean
    tipo?: "button" | "submit" | "reset"
}
export function Botao({ modelo, tipo, carregando, texto, variante, onClick, cor, corDeFundo, desabilitarBotao, altura, largura }: BotaoProps) {
    return (
        <>
            <BotaoCustomizado
                modelo={modelo}
                variant={variante}
                onClick={onClick}
                style={{ color: cor, backgroundColor: corDeFundo, width: largura, height: altura }}
                disabled={carregando || desabilitarBotao}
                type={tipo ? tipo : "button"}
            >

                {
                    carregando ? <CircularProgress sx={{
                        color: '#666CFF'
                    }} /> : texto

                }
            </BotaoCustomizado >

        </>
    );
}